import React, { FC } from 'react';
import { StoreCardImageProps } from './storeCardImage.types';
import {
  Container,
  Header,
  HeaderRightContainer,
  HeaderTitle,
  MidContainer
} from './storeCardImage.styles';
const StoreCardImage: FC<StoreCardImageProps> = (props) => {
  const bottomLeftValue = props.bottomLeftValue;
  return (
    <div style={{ marginBottom: '20px' }}>
      <Container backgroundColor={props.backgroundColor}>
        <Header>
          <div
            style={{ display: 'flex', alignItems: 'center', maxWidth: '85%' }}
          >
            <img
              src={props?.headerLogoLink}
              height={10}
              width={10}
              style={{ objectFit: 'cover' }}
            />

            <HeaderTitle textColor={props.textColor}>
              {props.headerTitle}
            </HeaderTitle>
          </div>
          <HeaderRightContainer>
            <div style={{ color: props.titleColor }}>{props.title}</div>
            <div style={{ color: props.textColor }}>{props.mainTitle}</div>
          </HeaderRightContainer>
        </Header>

        <img
          src={props.bannerImage}
          width={100}
          height={30}
          style={{ objectFit: 'cover' }}
        />
        <MidContainer>
          {bottomLeftValue && (
            <div>
              <div style={{ color: props.titleColor }}>
                {props.bottomLeftTitle?.toUpperCase()}
              </div>
              <div style={{ color: props.textColor }}>
                {props.bottomLeftValue}
              </div>
            </div>
          )}
          <div style={{ textAlign: bottomLeftValue ? 'end' : 'start' }}>
            <div style={{ color: props.titleColor }}>
              {props.bottomRightTitle?.toUpperCase()}
            </div>
            <div style={{ color: props.textColor }}>
              {props.bottomRightValue}
            </div>
          </div>
        </MidContainer>
      </Container>
      <div style={{ textAlign: 'center', marginTop: 10, fontWeight: 600 }}>
        {props.cardTitle ? props.cardTitle : 'Carte de fidélité'}
      </div>
    </div>
  );
};

export default StoreCardImage;
